import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import moment from 'moment-timezone';
import classNames from 'classnames';
import {
  // LineChart,
  // Line,
  BarChart,
  Bar,
  // PieChart,
  // Pie,
  // Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ReportText from '../../components/molecules/ReportText';
import ApplyButton from '../../components/atoms/ApplyButton';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getGeneralReportSummary,
  getFilteredReportSummary,
  getReportGochiUserCounts,
  getReportGochiCounts,
  getReportShopGochiTable
} from '../../actions/Reports';
import { getAccounts } from '../../actions/Accounts';
import ReportShopGochiAmountTableAdmin from '../organisms/ReportShopGochiAmountTableAdmin';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20,
    padding: '10px 20px'
  },
  lineDataBlock: {
    marginTop: 15,
    marginBottom: 15
  },
  textDataFlex: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around'
  },
  dataColumnFlex: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  customDateDiv: {
    display: 'flex',
    justifyContent: 'center'
  },
  textField: {
    padding: 5,
    width: '200px'
  },
  chartDataFlex: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  dataPaper: {
    padding: 10
  },
  dataPaperOverflow: {
    padding: 10,
    // height: '500px',
    overflow: 'auto'
  },
  dataPaperOneItem: {
    flexBasis: '100%'
  },
  dataPaperTwoItem: {
    flexBasis: '46%'
  },
  dataPaperThreeItem: {
    flexBasis: '30%'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  fontBold: {
    fontWeight: 'bold'
  },
  overflowItemBlock: {
    padding: 10
  },
  applyButtonParent: {
    position: 'relative'
  },
  applyButton: {
    position: 'absolute',
    bottom: 8
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      summaryGeneralData: state.reports.summaryGeneralData,
      summaryCumulativeData: state.reports.summaryCumulativeData,
      summaryFilteredData: state.reports.summaryFilteredData,
      gochiUserCountData: state.reports.gochiUserCountData,
      shopGochiTableData: state.reports.shopGochiTableData
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getGeneralReportSummary,
          getFilteredReportSummary,
          getReportGochiUserCounts,
          getReportGochiCounts,
          getReportShopGochiTable
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('page', 'setPage', 1),

  // platform
  withState('couponMoneyBuyWebTotal', 'setCouponMoneyBuyWebTotal', 0),
  withState('couponMoneyBuyAppTotal', 'setCouponMoneyBuyAppTotal', 0),
  withState('shashokuMoneyUseTotal', 'setShashokuMoneyUseTotal', 0),
  // gochiusertype
  withState('couponMoneyBuyUser', 'setCouponMoneyBuyUser', 0),
  withState('couponMoneyBuyNonuser', 'setCouponMoneyBuyNonuser', 0),
  withState('couponMoneyBuyAnyone', 'setCouponMoneyBuyAnyone', 0),
  withState('couponMoneyBuyYourself', 'setCouponMoneyBuyYourself', 0),
  withState('shashokuMoneyUse', 'setShashokuMoneyUse', 0),
  // gochi count
  withState('couponCountBuyUser', 'setCouponCountBuyUser', 0),
  withState('couponCountBuyNonuser', 'setCouponCountBuyNonuser', 0),
  withState('couponCountBuyAnyone', 'setCouponCountBuyAnyone', 0),
  withState('couponCountBuyYourself', 'setCouponCountBuyYourself', 0),
  withState('shashokuCount', 'setShashokuCount', 0),

  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('shopName', 'setShopName', ''),
  withState('dateFrom', 'setDateFrom', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment()
      .date(1)
      .format('YYYY-MM-DD');
  }),
  withState('dateTo', 'setDateTo', () => {
    return moment()
      .endOf('month')
      .format('YYYY-MM-DD');
  }),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      const feeParam = { includedFee: true };
      const customDate = {
        from: this.props.dateFrom,
        to: this.props.dateTo
      };
      const gochiType = { summaryType: 'GOCHI_TYPE' };
      // サマリー・月間
      const monthDate = {
        from: moment()
          .date(1)
          .format('YYYY-MM-DD'),
        to: moment()
          .endOf('month')
          .format('YYYY-MM-DD')
      };
      this.props.actions
        .getGeneralReportSummary({ ...monthDate, ...feeParam })
        .then(data => this.props.checkSession(data));
      // サマリー・カスタム
      this.props.actions.getFilteredReportSummary({
        ...customDate,
        ...feeParam
      });
      this.props.actions.getReportGochiCounts({
        ...customDate,
        ...gochiType
      });
      // 店舗別売上一覧
      this.props.actions.getReportShopGochiTable({
        ...customDate,
        page: this.props.page,
        limit: this.props.rowsPerPage,
        order: `${
          this.props.orderBy ? this.props.orderBy + this.props.order : ''
        }`
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    account,
    summaryGeneralData,
    summaryFilteredData,
    openDrawer,
    updateOpenDrawer,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    shopGochiTableData,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    couponMoneyBuyWebTotal,
    setCouponMoneyBuyWebTotal,
    couponMoneyBuyAppTotal,
    setCouponMoneyBuyAppTotal,
    shashokuMoneyUseTotal,
    setShashokuMoneyUseTotal,
    couponMoneyBuyUser,
    setCouponMoneyBuyUser,
    couponMoneyBuyNonuser,
    setCouponMoneyBuyNonuser,
    couponMoneyBuyAnyone,
    setCouponMoneyBuyAnyone,
    couponMoneyBuyYourself,
    setCouponMoneyBuyYourself,
    shashokuMoneyUse,
    setShashokuMoneyUse,

    couponCountBuyUser,
    couponCountBuyNonuser,
    couponCountBuyAnyone,
    couponCountBuyYourself,
    shashokuCount,
    setCouponCountBuyUser,
    setCouponCountBuyNonuser,
    setCouponCountBuyAnyone,
    setCouponCountBuyYourself,
    setShashokuCount
  }) => {
    const getMoneyBuyTotalValue = () => {
      if (summaryFilteredData.platform) {
        let couponMoneyBuyWebTotalValue = 0;
        let couponMoneyBuyAppTotalValue = 0;
        let shashokuMoneyUseTotalValue = 0;
        summaryFilteredData.platform.forEach(platformDayValue => {
          couponMoneyBuyWebTotalValue += platformDayValue.couponMoneyBuyWeb;
          couponMoneyBuyAppTotalValue += platformDayValue.couponMoneyBuyApp;
          shashokuMoneyUseTotalValue += platformDayValue.shashokuMoneyUse;
        });
        setCouponMoneyBuyWebTotal(couponMoneyBuyWebTotalValue);
        setCouponMoneyBuyAppTotal(couponMoneyBuyAppTotalValue);
        setShashokuMoneyUseTotal(shashokuMoneyUseTotalValue);
      }

      if (summaryFilteredData.gochiUserType) {
        let couponMoneyBuyUserValue = 0;
        let couponMoneyBuyNonuserValue = 0;
        let couponMoneyBuyAnyoneValue = 0;
        let couponMoneyBuyYourselfValue = 0;
        let shashokuMoneyUseValue = 0;

        let couponCountBuyUserValue = 0;
        let couponCountBuyNonuserValue = 0;
        let couponCountBuyAnyoneValue = 0;
        let couponCountBuyYourselfValue = 0;
        let shashokuCountValue = 0;

        summaryFilteredData.gochiUserType.forEach(gochiUserTypeDayValue => {
          couponMoneyBuyUserValue += gochiUserTypeDayValue.couponMoneyBuyUser;
          couponMoneyBuyNonuserValue +=
            gochiUserTypeDayValue.couponMoneyBuyNonuser;
          couponMoneyBuyAnyoneValue +=
            gochiUserTypeDayValue.couponMoneyBuyAnyone;
          couponMoneyBuyYourselfValue +=
            gochiUserTypeDayValue.couponMoneyBuyYourself;
          shashokuMoneyUseValue += gochiUserTypeDayValue.shashokuMoneyUse;

          couponCountBuyUserValue += gochiUserTypeDayValue.couponCountBuyUser;
          couponCountBuyNonuserValue +=
            gochiUserTypeDayValue.couponCountBuyNonuser;
          couponCountBuyAnyoneValue +=
            gochiUserTypeDayValue.couponCountBuyAnyone;
          couponCountBuyYourselfValue +=
            gochiUserTypeDayValue.couponCountBuyYourself;
          shashokuCountValue += gochiUserTypeDayValue.shashokuCount;
        });

        setCouponMoneyBuyUser(couponMoneyBuyUserValue);
        setCouponMoneyBuyNonuser(couponMoneyBuyNonuserValue);
        setCouponMoneyBuyAnyone(couponMoneyBuyAnyoneValue);
        setCouponMoneyBuyYourself(couponMoneyBuyYourselfValue);
        setShashokuMoneyUse(shashokuMoneyUseValue);

        // get gochi count
        setCouponCountBuyUser(couponCountBuyUserValue);
        setCouponCountBuyNonuser(couponCountBuyNonuserValue);
        setCouponCountBuyAnyone(couponCountBuyAnyoneValue);
        setCouponCountBuyYourself(couponCountBuyYourselfValue);
        setShashokuCount(shashokuCountValue);
      }
    };

    useEffect(() => {
      if (summaryFilteredData) {
        getMoneyBuyTotalValue();
      }
    }, [summaryFilteredData]);
    const handleChangeRowsPerPage = event => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      setPage(1);
      const limit = event.target.value;
      setRowsPerPage(limit);
      const customDate = {
        from: dateFrom,
        to: dateTo
      };
      console.log('CUSTOM DATE: ', customDate);
      actions.getReportShopGochiTable({
        ...customDate,
        page: 1,
        limit,
        order: `${orderBy ? orderBy + order : ''}`
      });
    };
    const handleChangePage = (event, p) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      setPage(p);
      const customDate = {
        from: dateFrom,
        to: dateTo
      };
      actions.getReportShopGochiTable({
        ...customDate,
        page: p,
        limit: rowsPerPage,
        order: `${orderBy ? orderBy + order : ''}`
      });
    };
    const handleRequestSort = property => {
      const isDesc = orderBy === property && order === 'Desc';
      const orderStr = isDesc ? 'Asc' : 'Desc';
      setOrder(orderStr);
      setOrderBy(property);
      const customDate = {
        from: dateFrom,
        to: dateTo
      };
      actions.getReportShopGochiTable({
        ...customDate,
        page,
        limit: rowsPerPage,
        order: `${property + orderStr}`
      });
    };

    const applyDate = {
      from: dateFrom,
      to: dateTo
    };
    const getCustomReport = () => {
      const feeParam = { includedFee: true };
      // サマリー・カスタム
      actions
        .getFilteredReportSummary({ ...applyDate, ...feeParam })
        .then(data => checkSession(data));
      // 店舗別売上一覧
      actions.getReportShopGochiTable({
        ...applyDate,
        page,
        limit: rowsPerPage,
        order: `${orderBy ? orderBy + order : ''}`
      });
    };
    const applyAction = () => {
      getCustomReport();
    };

    const labelFormatter = (value, totalAmount) => {
      if (totalAmount && totalAmount !== 0) {
        if (value === 0) {
          return `${value} (${value}%)`;
        }
        return `${value} (${((value * 100) / totalAmount).toFixed(1)}%)`;
      }
      return `${value}`;
    };

    const formatLegendPlatFormLabel = (value, entry, index) => {
      switch (index) {
        case 0:
          return `${value} ${labelFormatter(
            couponMoneyBuyWebTotal,
            summaryFilteredData.buyGochiAmount
          )}`;
        case 1:
          return `${value} ${labelFormatter(
            couponMoneyBuyAppTotal,
            summaryFilteredData.buyGochiAmount
          )}`;
        case 2:
          return `${value} ${labelFormatter(
            shashokuMoneyUseTotal,
            summaryFilteredData.buyGochiAmount
          )}`;
        default:
          return ``;
      }
    };

    const formatLegendGochiUserTypeLabel = (value, entry, index) => {
      switch (index) {
        case 0:
          return `${value} ${labelFormatter(
            couponMoneyBuyUser,
            summaryFilteredData.buyGochiAmount
          )}`;
        case 1:
          return `${value} ${labelFormatter(
            couponMoneyBuyNonuser,
            summaryFilteredData.buyGochiAmount
          )}`;
        case 2:
          return `${value} ${labelFormatter(
            couponMoneyBuyAnyone,
            summaryFilteredData.buyGochiAmount
          )}`;
        case 3:
          return `${value} ${labelFormatter(
            couponMoneyBuyYourself,
            summaryFilteredData.buyGochiAmount
          )}`;
        case 4:
          return `${value} ${labelFormatter(
            shashokuMoneyUse,
            summaryFilteredData.buyGochiAmount
          )}`;
        default:
          return ``;
      }
    };

    const formatLegendGochiCountLabel = (value, entry, index) => {
      switch (index) {
        case 0:
          return `${value} ${labelFormatter(
            couponCountBuyUser,
            summaryFilteredData.buyGochiCount
          )}`;
        case 1:
          return `${value} ${labelFormatter(
            couponCountBuyNonuser,
            summaryFilteredData.buyGochiCount
          )}`;
        case 2:
          return `${value} ${labelFormatter(
            couponCountBuyAnyone,
            summaryFilteredData.buyGochiCount
          )}`;
        case 3:
          return `${value} ${labelFormatter(
            couponCountBuyYourself,
            summaryFilteredData.buyGochiCount
          )}`;
        case 4:
          return `${value} ${labelFormatter(
            shashokuCount,
            summaryFilteredData.buyGochiCount
          )}`;
        default:
          return ``;
      }
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            サマリーレポート
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div
            className={classNames(classes.lineDataBlock, classes.textDataFlex)}
          >
            <div className={classes.textDataColumnFlex}>
              <ReportText
                dataTitle="月間ユーザー数"
                dataValue={summaryGeneralData.newRegisterUserCount}
              />
              <ReportText
                dataTitle="累計"
                dataValue={summaryGeneralData.availableUserCount}
                small
              />
            </div>
            <div className={classes.textDataColumnFlex}>
              <ReportText
                dataTitle="月間店舗数"
                dataValue={summaryGeneralData.openShopCount}
              />
              <ReportText
                dataTitle="累計"
                dataValue={summaryGeneralData.availableShopCount}
                small
              />
            </div>
            <div className={classes.textDataColumnFlex}>
              <ReportText
                dataTitle="月間ごち数"
                dataValue={summaryGeneralData.buyGochiCount}
              />
              <ReportText
                dataTitle="累計"
                dataValue={summaryGeneralData.buyGochiTotalCount}
                small
              />
            </div>
            <div className={classes.textDataColumnFlex}>
              <ReportText
                dataTitle="月間ごち額"
                dataValue={summaryGeneralData.buyGochiAmount}
              />
              <ReportText
                dataTitle="累計"
                dataValue={summaryGeneralData.buyGochiTotalAmount}
                small
              />
            </div>
            <div className={classes.textDataColumnFlex}>
              <ReportText
                dataTitle="月間ごち消化数"
                dataValue={summaryGeneralData.useGochiCount}
              />
              <ReportText
                dataTitle="累計"
                dataValue={summaryGeneralData.useGochiTotalCount}
                small
              />
            </div>
          </div>
          <Paper className={classes.lineDataBlock} elevation={2}>
            <div className={classes.customDateDiv}>
              <TextField
                label="From"
                type="date"
                className={classes.textField}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                value={dateFrom}
                onChange={e => {
                  setDateFrom(e.target.value);
                }}
              />
              <TextField
                label="To"
                type="date"
                className={classes.textField}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                value={dateTo}
                onChange={e => {
                  setDateTo(e.target.value);
                }}
              />
              <div className={classes.applyButtonParent}>
                <div className={classes.applyButton}>
                  <ApplyButton onClickAction={applyAction} />
                </div>
              </div>
            </div>
          </Paper>
          <div
            className={classNames(classes.lineDataBlock, classes.textDataFlex)}
          >
            <ReportText
              dataTitle="ユーザー数"
              dataValue={summaryFilteredData.newRegisterUserCount}
            />
            <ReportText
              dataTitle="店舗数"
              dataValue={summaryFilteredData.openShopCount}
            />
            <ReportText
              dataTitle="ごち数"
              dataValue={summaryFilteredData.buyGochiCount}
            />
            <ReportText
              dataTitle="ごち額"
              dataValue={summaryFilteredData.buyGochiAmount}
            />
            <ReportText
              dataTitle="ごち消化数"
              dataValue={summaryFilteredData.useGochiCount}
            />
          </div>
          <div
            className={classNames(classes.lineDataBlock, classes.chartDataFlex)}
          >
            <Paper
              className={classNames(
                classes.dataPaper,
                classes.dataPaperOneItem
              )}
              elevation={2}
            >
              <Typography component="h2" variant="h5" color="textSecondary">
                売上額
              </Typography>
              <ResponsiveContainer width="98%" minWidth={610} height={300}>
                <BarChart
                  data={summaryFilteredData.platform}
                  margin={{
                    top: 20,
                    right: 20,
                    left: 20,
                    bottom: 10
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="dayStatistic" />
                  <YAxis />
                  <Tooltip />
                  <Legend formatter={formatLegendPlatFormLabel} />
                  <Bar
                    dataKey="couponMoneyBuyWeb"
                    name="Web"
                    stackId="a"
                    fill="#8884d8"
                  />
                  <Bar
                    dataKey="couponMoneyBuyApp"
                    name="アプリ"
                    stackId="a"
                    fill="#82ca9d"
                  />
                  <Bar
                    dataKey="shashokuMoneyUse"
                    name="社食"
                    stackId="a"
                    fill="#cab882"
                  />
                </BarChart>
              </ResponsiveContainer>
            </Paper>
          </div>
          <div
            className={classNames(classes.lineDataBlock, classes.chartDataFlex)}
          >
            <Paper
              className={classNames(
                classes.dataPaper,
                classes.dataPaperOneItem
              )}
              elevation={2}
            >
              <Typography component="h2" variant="h5" color="textSecondary">
                売上額
              </Typography>
              <ResponsiveContainer width="98%" minWidth={610} height={300}>
                <BarChart
                  data={summaryFilteredData.gochiUserType}
                  margin={{
                    top: 20,
                    right: 20,
                    left: 20,
                    bottom: 10
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="dayStatistic" />
                  <YAxis />
                  <Tooltip />
                  <Legend formatter={formatLegendGochiUserTypeLabel} />
                  <Bar
                    dataKey="couponMoneyBuyUser"
                    name="ご指名ごち"
                    stackId="a"
                    fill="#82CA9D"
                  />
                  <Bar
                    dataKey="couponMoneyBuyNonuser"
                    name="外部ユーザごち"
                    stackId="a"
                    fill="#CAB882"
                  />
                  <Bar
                    dataKey="couponMoneyBuyAnyone"
                    name="オープンごち"
                    stackId="a"
                    fill="#8884D8"
                  />
                  <Bar
                    dataKey="couponMoneyBuyYourself"
                    name="自分へのごち"
                    stackId="a"
                    fill="#DB8FAC"
                  />
                  <Bar
                    dataKey="shashokuMoneyUse"
                    name="社食チケット"
                    stackId="a"
                    fill="#CDDA7F"
                  />
                </BarChart>
              </ResponsiveContainer>
            </Paper>
          </div>
          <div
            className={classNames(classes.lineDataBlock, classes.chartDataFlex)}
          >
            <Paper
              className={classNames(
                classes.dataPaper,
                classes.dataPaperOneItem
              )}
              elevation={2}
            >
              <Typography component="h2" variant="h5" color="textSecondary">
                ごちった数
              </Typography>
              <ResponsiveContainer width="98%" minWidth={610} height={300}>
                <BarChart
                  width={610}
                  height={300}
                  data={summaryFilteredData.gochiUserType}
                  margin={{
                    top: 20,
                    right: 20,
                    left: 20,
                    bottom: 10
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="dayStatistic" />
                  <YAxis />
                  <Tooltip />
                  <Legend formatter={formatLegendGochiCountLabel} />
                  <Bar
                    dataKey="couponCountBuyUser"
                    name="ご指名ごち"
                    stackId="a"
                    fill="#82CA9D"
                  />
                  <Bar
                    dataKey="couponCountBuyNonuser"
                    name="外部ユーザごち"
                    stackId="a"
                    fill="#CAB882"
                  />
                  <Bar
                    dataKey="couponCountBuyAnyone"
                    name="オープンごち"
                    stackId="a"
                    fill="#8884D8"
                  />
                  <Bar
                    dataKey="couponCountBuyYourself"
                    name="自分へのごち"
                    stackId="a"
                    fill="#DB8FAC"
                  />
                  <Bar
                    dataKey="shashokuCount"
                    name="社食チケット"
                    stackId="a"
                    fill="#CDDA7F"
                  />
                </BarChart>
              </ResponsiveContainer>
            </Paper>
          </div>
          <div
            className={classNames(classes.lineDataBlock, classes.chartDataFlex)}
          >
            <Paper
              className={classNames(
                classes.dataPaperOverflow,
                classes.dataPaperOneItem
              )}
              elevation={2}
            >
              <ReportShopGochiAmountTableAdmin
                shopGochiAmounts={shopGochiTableData}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handleChangePage={handleChangePage}
                handleRequestSort={handleRequestSort}
                page={page}
                rowsPerPage={rowsPerPage}
                order={order}
                orderBy={orderBy}
              />
            </Paper>
          </div>
        </Paper>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
